module.exports = __webpack_public_path__ + "img/scord_bright.85c1b43f.png";